// eslint-disable-next-line import/prefer-default-export
export const REMOVE_AUTH_TOKEN = 'REMOVE_AUTH_TOKEN'
export const UPDATE_PREFERRED_PLATFORM = 'UPDATE_PREFERRED_PLATFORM'
